import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Input from "../../../components/ui/Input";
import Button from "../../../components/ui/Button";
import {
  confirmSignup,
  resendConfirmation,
  login,
} from "../../../services/authService";
import { navigateAfterAuth } from "../../../utils/postAuthNavigation";

const ConfirmEmailForm = ({ email: initialEmail, passwordForAutoLogin }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState(initialEmail || "");
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [info, setInfo] = useState(
    "Digite o código enviado para o seu e-mail para ativar a conta."
  );
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);

  const handleConfirm = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const result = await confirmSignup({ email, code });

      if (!result.ok) {
        setError(
          result.data?.message || "Não foi possível confirmar o e-mail."
        );
        return;
      }

      setInfo(result.data?.message || "E-mail confirmado com sucesso.");

      if (passwordForAutoLogin) {
        const loginResult = await login({
          email,
          password: passwordForAutoLogin,
        });
        if (loginResult.ok) {
          await navigateAfterAuth(navigate, null);
          return;
        }
      }

      navigate("/login", {
        replace: true,
        state: { confirmed: true, email },
      });
    } catch {
      setError("Erro de conexão. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setError("");
    setResending(true);
    try {
      const result = await resendConfirmation({ email });
      if (result.ok) {
        setInfo(result.data?.message || "Novo código enviado.");
      } else {
        setError(result.data?.message || "Não foi possível reenviar o código.");
      }
    } catch {
      setError("Erro de conexão. Tente novamente.");
    } finally {
      setResending(false);
    }
  };

  return (
    <form onSubmit={handleConfirm} className="space-y-4">
      <p className="text-sm text-muted-foreground">{info}</p>

      <Input
        label="E-mail"
        type="email"
        required
        autoComplete="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="seu@email.com"
      />
      <Input
        label="Código de confirmação"
        type="text"
        required
        inputMode="numeric"
        autoComplete="one-time-code"
        value={code}
        onChange={(e) => setCode(e.target.value.replace(/\s/g, ""))}
        placeholder="123456"
      />

      {error && (
        <p className="text-sm text-destructive" role="alert">
          {error}
        </p>
      )}

      <Button type="submit" size="lg" fullWidth loading={loading} disabled={loading}>
        Confirmar e-mail
      </Button>

      <Button
        type="button"
        variant="outline"
        size="lg"
        fullWidth
        loading={resending}
        disabled={resending || !email}
        onClick={handleResend}
      >
        Reenviar código
      </Button>
    </form>
  );
};

export default ConfirmEmailForm;
